import { useQuery } from '@tanstack/react-query'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { StoriesService } from '../lib/stories.service'

const GET_STORIES = 'get-stories'

export const useStories = () => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  return useQuery({
    queryKey: [GET_STORIES, projectId],
    queryFn: () => StoriesService.getStories(projectId, 'comfort'),
    select: data => data.data
  })
}
